// import moment from 'moment';
import { buildDownloadData, getCountryByCode } from '@intelligence/utils/commonUtils';

const SENSORTOWER = 'sensortower';
const APPANNIE = 'appannie';

// 使用buildDownloadData，获取GenreProfileDetailStats下载表头与表体
export const expandDataGenreProfileTopChartsPlus = (
  list: any,
  params: any = {},
  regionOptions: any,
  downloadKey = '',
) => {
  // console.log('expandDataGenreProfileTopChartsPlus-list1212', list);
  // console.log('expandDataGenreProfileTopChartsPlus-params1212', params);
  // console.log('expandDataGenreProfileTopChartsPlus-regionOptions', regionOptions);
  const ext = list?.$ext || {};
  const regionMarketNameMapping = ext?.market_info || {};
  const intelRegionNameCNMap = regionMarketNameMapping?.['intel_region -> cn'] || {};
  const intelRegionNameENMap = regionMarketNameMapping?.['intel_region -> en'] || {};
  const regionNameCNMap = regionMarketNameMapping?.['region -> cn'] || {};
  const regionNameENMap = regionMarketNameMapping?.['region -> en'] || {};
  const listTemp = list.list || [];

  // key支持的取值（string和function）
  // 不写when默认抓取，否则根据when的结果
  // listTemp = listTemp.sort((a: any, b: any) => {
  //   // 第一优先级：按 gameId 升序
  //   if (a.game_id !== b.game_id) return a.game_id - b.game_id;
  //   // 第二优先级：按 time 降序（新时间在前）
  //   if (b.date !== a.date) return moment(b?.date).diff(moment(a?.date));
  //   // 第三优先级: 国家字母升序
  //   const deviceCompare = a?.market?.localeCompare(b?.market);
  //   if (deviceCompare !== 0) return deviceCompare;
  //   // 第四优先级：按 device 字母升序（A-Z）
  //   return 0;
  // });
  let config: any = [];
  const source = params?.filter?.sourceMetrics || SENSORTOWER;
  const entityType = params?.entity_type || 'mobile';
  const isTotal = entityType === 'total';

  const rankList = [
    {
      title: 'Rank',
      key: (item: any) => item?.rank || '',
      when: () => params?.downlaod_date_method === 'aggregated' && params?.region_method === 'aggregated',
    },
  ];

  const commonMetricList = [
    {
      title: 'Country_Chinese',
      key: (item: any) => {
        const itemMarket = item?.market || '';
        return getCountryByCode(itemMarket, regionOptions)?.country_name_ch || itemMarket || '';
      },
      when: () => params?.region_method === 'market',
    },
    {
      title: 'Country_English',
      key: (item: any) => {
        const itemMarket = item?.market || '';
        return getCountryByCode(itemMarket, regionOptions)?.country_name_en || itemMarket || '';
      },
      when: () => params?.region_method === 'market',
    },
    {
      title: 'Region_Chinese',
      key: (item: any) => {
        const itemRegion = item?.region || '';
        return intelRegionNameCNMap?.[itemRegion] || regionNameCNMap?.[itemRegion] || itemRegion || '';
      },
      when: () => params?.region_method === 'region',
    },
    {
      title: 'Region_English',
      key: (item: any) => {
        const itemRegion = item?.region || '';
        return intelRegionNameENMap?.[itemRegion] || regionNameENMap?.[itemRegion] || itemRegion || '';
      },
      when: () => params?.region_method === 'region',
    },
    {
      title: 'Revenue(appannie)',
      key: (item: any) => item?.metrics?.appannie_revenue || '',
      when: () => source === APPANNIE && !isTotal,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics?.appannie_revenue_growth || '',
      when: () => source === APPANNIE && params.ratio_show == '1' && !isTotal,
    },
    {
      title: 'Revenue(sensortower)',
      key: (item: any) => item?.metrics?.sensortower_revenue || '',
      when: () => source === SENSORTOWER && !isTotal,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics?.sensortower_revenue_growth || '',
      when: () => source === SENSORTOWER && params.ratio_show == '1' && !isTotal,
    },
    {
      title: 'Total Revenue($)',
      key: (item: any) => item?.metrics?.total_revenue || '',
      when: () => isTotal,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics?.total_revenue_growth || '',
      when: () => isTotal && params.ratio_show == '1',
    },
    {
      title: 'Downloads',
      key: (item: any) => item?.metrics?.sensortower_download || '',
      when: () => isTotal,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics?.sensortower_download_growth || '',
      when: () => isTotal && params.ratio_show == '1',
    },
    {
      title: 'Download(appannie)',
      key: (item: any) => item?.metrics?.appannie_download || '',
      when: () => source === APPANNIE && !isTotal,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics?.appannie_download_growth || '',
      when: () => source === APPANNIE && params.ratio_show == '1' && !isTotal,
    },
    {
      title: 'Download(sensortower)',
      key: (item: any) => item?.metrics?.sensortower_download || '',
      when: () => source === SENSORTOWER && !isTotal,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics?.sensortower_download_growth || '',
      when: () => source === SENSORTOWER && params.ratio_show == '1' && !isTotal,
    },
  ];

  if (downloadKey === 'genreProfileTopCharts-Main Genre') {
    config = [
      ...rankList,
      {
        title: 'Date',
        key: (item: any) => item?.date || '',
        when: () => params.downlaod_date_method !== 'aggregated',
      },
      {
        title: 'Platform',
        key: (item: any) => entityType || '',
      },
      {
        title: 'Main Genre',
        key: (item: any) => item?.genre || '',
      },
      ...commonMetricList,
    ];
  } else if (downloadKey === 'genreProfileTopCharts-Sub Genre') {
    config = [
      ...rankList,
      {
        title: 'Date',
        key: (item: any) => item?.date || '',
        when: () => params.downlaod_date_method !== 'aggregated',
      },
      {
        title: 'Platform',
        key: (item: any) => entityType || '',
      },
      {
        title: 'Sub Genre',
        key: (item: any) => item?.sub_genre || '',
      },
      ...commonMetricList,
    ];
  } else if (downloadKey === 'genreProfileTopCharts-Main+Sub Genre') {
    config = [
      ...rankList,
      {
        title: 'Date',
        key: (item: any) => item?.date || '',
        when: () => params.downlaod_date_method !== 'aggregated',
      },
      {
        title: 'Platform',
        key: (item: any) => entityType || '',
      },
      {
        title: 'Main Genre',
        key: (item: any) => item?.genre || '',
      },
      {
        title: 'Sub Genre',
        key: (item: any) => item?.sub_genre || '',
      },
      ...commonMetricList,
    ];
  }

  const result = buildDownloadData(config, listTemp);
  return result;
};
